import axios from 'axios'

class AnnouncementService {
  constructor() {
    // 使用相对路径，通过代理转发
    this.baseURL = process.env.NODE_ENV === 'production' 
      ? (process.env.VUE_APP_API_BASE_URL || '/api') 
      : '/api'
    this.storageKey = 'announcement_display_rules'
    this.maxDisplayPerDay = 3 // 每天最多展示3次
    this.minIntervalHours = 4 // 每次展示最小间隔4小时
  }

  /**
   * 获取有效的公告列表
   */
  async getActiveAnnouncements() {
    try {
      const response = await axios.get(`${this.baseURL}/announcement/announcements`)
      if (response.data.success) {
        return response.data.data || []
      }
      return []
    } catch (error) {
      console.error('获取公告列表失败:', error)
      return []
    }
  }

  /**
   * 获取用户展示规则
   */
  getDisplayRules() {
    try {
      const rules = localStorage.getItem(this.storageKey)
      return rules ? JSON.parse(rules) : {
        lastDisplayTime: null,
        todayDisplayCount: 0,
        lastDisplayDate: null,
        dismissedAnnouncements: []
      }
    } catch (error) {
      return {
        lastDisplayTime: null,
        todayDisplayCount: 0,
        lastDisplayDate: null,
        dismissedAnnouncements: []
      }
    }
  }

  /**
   * 保存用户展示规则
   */
  saveDisplayRules(rules) {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(rules))
    } catch (error) {
      console.error('保存展示规则失败:', error)
    }
  }

  /**
   * 检查是否需要展示公告
   */
  shouldDisplayAnnouncement(announcement) {
    const rules = this.getDisplayRules()
    const now = new Date()
    const today = now.toDateString()
    
    console.log('当前展示规则:', rules)
    console.log('当前时间:', now)
    console.log('公告开始时间:', announcement.start_time)
    console.log('公告结束时间:', announcement.end_time)
    
    // 检查是否已关闭该公告
    if (rules.dismissedAnnouncements.includes(announcement.id)) {
      console.log('公告已被用户关闭')
      return false
    }

    // 检查日期有效性
    if (announcement.start_time && new Date(announcement.start_time) > now) {
      console.log('公告开始时间未到')
      return false
    }
    if (announcement.end_time && new Date(announcement.end_time) < now) {
      console.log('公告已过期')
      return false
    }

    // 检查今日展示次数
    if (rules.lastDisplayDate === today && rules.todayDisplayCount >= this.maxDisplayPerDay) {
      console.log('今日展示次数已达上限')
      return false
    }

    // 检查时间间隔
    if (rules.lastDisplayTime) {
      const lastTime = new Date(rules.lastDisplayTime)
      const hoursDiff = (now - lastTime) / (1000 * 60 * 60)
      console.log('距离上次展示时间间隔:', hoursDiff, '小时')
      if (hoursDiff < this.minIntervalHours) {
        console.log('时间间隔不足')
        return false
      }
    }

    console.log('公告可以显示')
    return true
  }

  /**
   * 获取需要展示的公告
   */
  async getAnnouncementToDisplay() {
    const announcements = await this.getActiveAnnouncements()
    console.log('获取到的公告列表:', announcements)
    
    // 按优先级排序（优先级高的先展示）
    const sortedAnnouncements = announcements.sort((a, b) => {
      // 置顶公告优先
      if (a.is_sticky !== b.is_sticky) {
        return b.is_sticky - a.is_sticky
      }
      // 优先级高的优先
      return b.priority - a.priority
    })

    // 找到第一个需要展示的公告
    for (const announcement of sortedAnnouncements) {
      console.log('检查公告:', announcement.title, '是否应该显示')
      if (this.shouldDisplayAnnouncement(announcement)) {
        console.log('公告应该显示:', announcement.title)
        return announcement
      } else {
        console.log('公告不应该显示:', announcement.title)
      }
    }

    console.log('没有找到需要显示的公告')
    return null
  }

  /**
   * 记录公告展示
   */
  recordDisplay(announcementId) {
    const rules = this.getDisplayRules()
    const now = new Date()
    const today = now.toDateString()

    // 如果是新的一天，重置计数
    if (rules.lastDisplayDate !== today) {
      rules.todayDisplayCount = 0
      rules.lastDisplayDate = today
    }

    rules.todayDisplayCount++
    rules.lastDisplayTime = now.toISOString()

    this.saveDisplayRules(rules)
  }

  /**
   * 标记公告为已关闭
   */
  dismissAnnouncement(announcementId) {
    const rules = this.getDisplayRules()
    
    if (!rules.dismissedAnnouncements.includes(announcementId)) {
      rules.dismissedAnnouncements.push(announcementId)
      // 只保留最近关闭的10个公告，避免存储过大
      if (rules.dismissedAnnouncements.length > 10) {
        rules.dismissedAnnouncements = rules.dismissedAnnouncements.slice(-10)
      }
      this.saveDisplayRules(rules)
    }
  }

  /**
   * 重置展示规则（用于测试或特殊情况）
   */
  resetDisplayRules() {
    const rules = {
      lastDisplayTime: null,
      todayDisplayCount: 0,
      lastDisplayDate: null,
      dismissedAnnouncements: []
    }
    this.saveDisplayRules(rules)
  }

  /**
   * 获取展示统计信息
   */
  getDisplayStats() {
    const rules = this.getDisplayRules()
    const now = new Date()
    const today = now.toDateString()
    
    return {
      todayDisplayCount: rules.lastDisplayDate === today ? rules.todayDisplayCount : 0,
      lastDisplayTime: rules.lastDisplayTime,
      maxDisplayPerDay: this.maxDisplayPerDay,
      minIntervalHours: this.minIntervalHours
    }
  }


    /**
   * 检查是否应该展示公告（Home.vue调用的方法）
   */
  async shouldShowAnnouncement() {
    const announcement = await this.getAnnouncementToDisplay()
    return announcement !== null
  }

  /**
   * 获取当前需要展示的公告（Home.vue调用的方法）
   */
  async getCurrentAnnouncement() {
    return await this.getAnnouncementToDisplay()
  }

  /**
   * 记录公告展示（Home.vue调用的方法）
   */
  recordAnnouncementShow(announcementId) {
    this.recordDisplay(announcementId)
  }

  /**
   * 标记不再显示此公告（Home.vue调用的方法）
   */
  markAnnouncementNeverShow(announcementId) {
    this.dismissAnnouncement(announcementId)
  }
}


export default new AnnouncementService()